export default {
    getCarModel: { method: 'get', url: 'car/model//?model_name={model}' },
    getCarVersion: { method: 'get', url: 'car/?model__name={model__name}' },
    addCarGarage: { method: 'post', url: 'client/garagem/add/' },
  }